import configureStore from "./store/configureStore";
import { PubSubContext } from "./App";
import { Provider } from "react-redux";
import { useState, createContext } from "react";
import { THEME_LIGHT, THEME_DARK } from "./App.constant";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ProviderLanguage from "@Components/ProviderLanguage";

export const store = configureStore();

export const themes = {
  [THEME_LIGHT]: {
    rootBackground: "--surface-neutral",
    rootTextColor: "--primary-text",
    userNameTagComponentBackground: "--light-blue-tag",
  },
  [THEME_DARK]: {
    rootBackground: "--surface-black",
    rootTextColor: "--surface-neutral",
  },
};

export const ThemeContext = createContext({
  theme: themes[THEME_LIGHT],
});

export const muiTheme = createTheme({
  typography: {
    fontFamily: "inherit",
  },
  zIndex: {
    modal: 1200,
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
          "&:active": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiPopper: {
      defaultProps: {
        style: { zIndex: 1400 },
      },
    },
    MuiPopover: {
      defaultProps: {
        style: { zIndex: 1400 },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        popper: {
          zIndex: "1400 !important",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          "& .MuiTabs-indicator": {
            backgroundColor: "#6BBBE3",
            height: "4px",
            borderRadius: "2px",
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: "16px",
          padding: "0px",
          minWidth: "auto",
          marginRight: "24px", // 6 * 4px (default spacing unit)
          textTransform: "none",
          color: "var(--primary-text)",
          fontWeight: 400,

          // Selected state styling
          "&.Mui-selected": {
            fontWeight: 600,
            color: "var(--primary-text)",
          },
        },
      },
    },
  },
});

function ChildProviderApp({ children }) {
  const [theme, setTheme] = useState(THEME_LIGHT);

  return (
    <ProviderLanguage
      isRTLCallback={(isRTL) => {
        document.documentElement.dir = isRTL ? "rtl" : "ltr";
      }}
    >
      <ThemeProvider theme={muiTheme}>
        <PubSubContext.Provider>
          <ThemeContext.Provider
            value={{
              theme: themes[theme],
              setTheme,
              themes,
              themeType: theme,
            }}
          >
            {children}
          </ThemeContext.Provider>
        </PubSubContext.Provider>
      </ThemeProvider>
    </ProviderLanguage>
  );
}

function ProviderApp({ children }) {
  return (
    <Provider store={store}>
      <ChildProviderApp>{children}</ChildProviderApp>
    </Provider>
  );
}

export default ProviderApp;
